"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CollectionsCollection_1 = require("../DataModel/Collections/CollectionsCollection");
const ResourceFilterableCollection_1 = require("../DataModel/Collections/ResourceFilterableCollection");
const TypesCollection_1 = require("../DataModel/Collections/TypesCollection");
const namespaces_1 = require("../namespaces");
const link = new TypesCollection_1.default([namespaces_1.hydra.Link]);
function convertToResource(item, processingState) {
    let result = item || null;
    if (typeof item === "string") {
        result = processingState.getVisitedResource(item) || { iri: item, type: link };
    }
    return result;
}
function collection(mappings) {
    mappings[namespaces_1.hydra.totalItems] = {
        default: 0,
        propertyName: "totalItems",
        required: true,
        type: [namespaces_1.hydra.Collection]
    };
    mappings[namespaces_1.hydra.manages] = {
        default: (manages) => new ResourceFilterableCollection_1.default(manages.filter(_ => !!_.property && (!!_.subject || !!_.object))),
        propertyName: "manages",
        required: true,
        type: [namespaces_1.hydra.Collection]
    };
    mappings[namespaces_1.hydra.member] = {
        default: members => new ResourceFilterableCollection_1.default(members),
        propertyName: "members",
        type: [namespaces_1.hydra.Collection]
    };
    mappings[namespaces_1.hydra.collection] = {
        default: collections => new CollectionsCollection_1.default(collections),
        propertyName: "collections",
        required: true
    };
    mappings[namespaces_1.hydra.view] = {
        default: views => views[0] || null,
        propertyName: "view",
        type: [namespaces_1.hydra.Collection]
    };
    mappings[namespaces_1.hydra.first] = {
        default: (first, processingState) => convertToResource(first[0], processingState),
        propertyName: "first",
        type: [namespaces_1.hydra.Resource]
    };
    mappings[namespaces_1.hydra.last] = {
        default: (last, processingState) => convertToResource(last[0], processingState),
        propertyName: "last",
        type: [namespaces_1.hydra.Resource]
    };
    mappings[namespaces_1.hydra.next] = {
        default: (next, processingState) => convertToResource(next[0], processingState),
        propertyName: "next",
        type: [namespaces_1.hydra.Resource]
    };
    mappings[namespaces_1.hydra.previous] = {
        default: (previous, processingState) => convertToResource(previous[0], processingState),
        propertyName: "previous",
        type: [namespaces_1.hydra.Resource]
    };
    return mappings;
}
exports.collection = collection;
//# sourceMappingURL=collection.js.map